import { Auth0Provider } from '@auth0/auth0-react';
import ReactDOM from 'react-dom';

/* ORDER is important here Toastfy needs to be first to loose priority */
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import App from './content/app';
import { store } from './store/store'
import { Provider } from 'react-redux'
import { config } from './constants'

ReactDOM.render(
  <Auth0Provider
    domain={config.auth0.domain}
    clientId={config.auth0.clientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: config.auth0.audience,
      scope: "openid profile email read:all offline_access"
    }}
    useRefreshTokens
    cacheLocation="localstorage"
  >
    <Provider store={store}>
      <App />
    </Provider>
  </Auth0Provider>,
  document.getElementById('root')
);
